import { servicesAPI } from "./api"
import { parseServicesCallbackWithValue } from "./api/services"
import { RelativeSiblingsResponse } from "./models/relativesiblings"

export const getRelativeSiblings = (
    location: string,
    filter: string | null,
    size: number | null,
    afterPageId: string | null,
): Promise<RelativeSiblingsResponse> =>
    servicesAPI.postJSON(
        "GetRelativeSiblings",
        { location, filter, size, afterPageId },
        parseServicesCallbackWithValue<RelativeSiblingsResponse>,
    )

export const reorderRelativeSibling = (
    targetLocation: number,
    reorderedSiblingId: string,
    location: string,
    filter: string | null,
    size: number | null,
): Promise<RelativeSiblingsResponse> =>
    servicesAPI.postJSON(
        "ReorderRelativeSibling",
        { targetLocation, reorderedSiblingId, location, filter, size },
        parseServicesCallbackWithValue<RelativeSiblingsResponse>,
    )

export const removeRelativeSibling = (
    selectionFilterId: string,
    location: string,
    filter: string | null,
    size: number | null,
): Promise<RelativeSiblingsResponse> =>
    servicesAPI.postJSON(
        "RemoveRelativeSibling",
        { selectionFilterId, location, filter, size },
        parseServicesCallbackWithValue<RelativeSiblingsResponse>,
    )
